import { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router';
import { ElevatedButton } from '@producer/ui-kit';

import { Card } from '../../components/on-boarding/Card';
import { useAuth } from '../../cree8-auth';
import { ProducerLogo } from '../../components/icons/producer-logo';
import { globalConfig } from '../../configuration/config';

import type { Cree8SigninState } from '../../cree8-auth';

import styles from './index.module.scss';
export const SSOPage = () => {
  const { alias } = useParams();
  const auth = useAuth();

  const [space, setSpace] = useState<{ _id: string; name: string }>();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const baseUrl = globalConfig.config.baseApiUrl.replace('/v1', '');
    axios.get(`${baseUrl}/public/spaces/${alias}`).then(({ data }) => {
      setSpace(data);
      setIsLoading(false);
    });
  }, [alias]);

  const handleSSOLogin = () => {
    if (!space) {
      return;
    }

    // CREE8 matches redirect_uri byte-for-byte against the single registered
    // origin, so we must not append a path here — let it default to the
    // provider's registered `window.location.origin` and route on return via
    // `state`, which onSigninCallback reads back. This page is only an entry
    // point to the IdP, so send the user home rather than back to it.
    void auth.signinRedirect({
      state: { returnTo: '/' } satisfies Cree8SigninState,
      extraQueryParams: { idp_hint: alias ?? '' },
    });
  };

  if (isLoading) {
    return <div className={styles['page']} />;
  }

  if (!space) {
    return <div className={styles['page']} />;
  }

  return (
    <div className={styles['page']}>
      <div className={styles['container']}>
        <div className={styles['content']}>
          <ProducerLogo />

          <Card
            title={`Single sign-on to ${space.name}`}
            subtitle={`Authenticate your account by logging into ${space.name}’s single sign-on provider.`}
          >
            <ElevatedButton text="Continue" onClick={handleSSOLogin} />
          </Card>
        </div>
      </div>
    </div>
  );
};
